import React, { AnchorHTMLAttributes } from 'react';
import { BaseRouteParams, Link } from '@sls-react/routing';
import A from '@sls-react/components/Links/A';
import qsStringify from '@sls-react/utils/qsStringify';

interface SellerDashboardLinkOptions {
  page?:
    | 'balance'
    | 'cashout'
    | 'create'
    | 'editContact'
    | 'createBank'
    | 'editBank'
    | 'createCompleted'
    | 'w9'
    | 'documents';
}

export function generateSellerDashboardLink({
  page,
  ...options
}: SellerDashboardLinkOptions & BaseRouteParams = {}): string {
  let destination = '/selling';

  switch (page) {
    case 'cashout':
      destination += '/cashout';
      break;

    case 'create':
      destination += '/create';
      break;

    case 'createBank':
      destination += '/create/bank';
      break;
    case 'createCompleted':
      destination += '/create/completed';
      break;

    case 'editContact':
      destination += '/edit/contact';
      break;

    case 'editBank':
      destination += '/edit/bank';
      break;

    case 'w9':
      destination += '/w9';
      break;

    case 'documents':
      destination += '/documents';
      break;
  }

  return destination + qsStringify(options);
}

type Props = Omit<AnchorHTMLAttributes<HTMLAnchorElement>, 'href'> &
  SellerDashboardLinkOptions & {
    passHref?: boolean;
  };

const SellerDashboardLink: React.FC<Props> = ({
  children,
  page,
  passHref = true,
  ...props
}) => {
  const destination = generateSellerDashboardLink({ page });

  return (
    <Link href={destination} passHref={passHref}>
      <A {...props}>{children}</A>
    </Link>
  );
};

export default SellerDashboardLink;
